import React from 'react';

/**
 * Shared date-and-time control for workflows that require a precise local time.
 * Values intentionally remain in the browser's datetime-local format so the
 * existing API payloads and timezone conversion continue to work unchanged.
 */
export default function DateTimeInput({ className = '', step = 60, ...props }) {
  return (
    <input
      {...props}
      type="datetime-local"
      step={step}
      className={`form-control app-date-time-control ${className}`.trim()}
    />
  );
}
